import { render, staticRenderFns } from "./SeparatorText.vue?vue&type=template&id=51b16c06&"
import script from "./SeparatorText.vue?vue&type=script&lang=js&"
export * from "./SeparatorText.vue?vue&type=script&lang=js&"
import style0 from "./SeparatorText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports